<template>
  <div class="trips-list-wrapper">
    <div class="loading text-center" v-if="isDeepLinkLoading">
      <div class="loader-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <h1>{{ $t("loadingtrips") }}</h1>
    </div>
    <div class="loaded" v-else>
      <div class="trips-list" v-if="hasTrips">
        <form @submit.prevent="submitDeparture">
          <h1 id="wb-cont" class="container">{{ $t("page2title") }}</h1>
          <staticErrorList v-bind:errors="errors" />
          <div class="trip-overview-wrapper">
            <div class="container">
              <div class="row">
                <div class="col-sm-3 trip-overview--departure">
                  <span>{{ $t("from") }}</span>
                  <br />
                  {{ currentFrom }}
                  <small> {{ $t("passengers") }}: {{ passengerDetails }}</small>
                </div>
                <div class="col-sm-3 trip-overview-arrow"></div>
                <div class="col-sm-3 trip-overview--destination">
                  <span>{{ $t("to") }}</span>
                  <br />
                  {{ currentTo }}
                </div>
                <div class="col-sm-3">
                  <span>{{ $t("departs") }}</span>
                  <br />
                  {{ tripDate }}
                </div>
              </div>
            </div>
          </div>
          <div class="container">
          <div class='col col-xs-12'>
            <div class='alert alert-info'>
            <i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp;
            <i18n path="unaccompaniedminors" tag="span">
                    <template #unaccompaniedLink>
                            <a :href="$t('unaccompaniedminorsUrl')" style="color: white; text-decoration: underline;" target="_blank">{{ $t('unaccompaniedminorsLinkText') }}</a>
                    </template>
            </i18n>
            </div>
          </div>
            <div class="col-xs-12">
              <div role="alert" class="alert alert-info">
                <i aria-hidden="true" class="fa fa-info-circle"></i>
                {{ $t("feesmayapply") }}
              </div>
            </div>
          </div>
          <div class="container">
            <h2>
              {{ $t("selectdeparture") }}
              <span
                class="label label-danger form-error"
                v-if="filterError('departure').length"
              >
                <strong>
                  <span class="prefix">{{ $t("errorPrefix") }}</span>
                  <span v-html="filterError('departure')[0].value"></span>
                </strong>
              </span>
            </h2>
            <div role="list" class="trip-list row" id="departure-trips">
              <tripItem
                v-for="departure in trips.departures"
                :key="departure.name"
                :data-trip="departure.id"
                v-bind:departure="departure"
                v-bind:selectedFaresStore="selectedFaresStore"
                tripdir="departure"
                @update-selected-class="updateClass"
              />
            </div>
          </div>
          <div
            class="container"
            v-if="hasTrips && this.tripType == 'roundtrip'"
          >
            <h2>
              {{ $t("selectreturn") }}
              <span
                class="label label-danger form-error"
                v-if="filterError('return').length"
              >
                <strong>
                  <span class="prefix">{{ $t("errorPrefix") }}</span>
                  <span v-html="filterError('return')[0].value"></span>
                </strong>
              </span>
            </h2>

            <div class="row list-headers hidden-xs">
              <div class="header-departure">{{ $t("thdeparture") }}</div>
              <div class="header-arrival">{{ $t("tharrival") }}</div>
              <div class="header-firm">{{ $t("thfirm") }}</div>
              <div class="header-flexible">{{ $t("thflexible") }}</div>
            </div>
            <div role="list" class="trip-list row" id="return-trips">
              <tripItem
                v-for="returnt in trips.returns"
                :key="returnt.name"
                :data-trip="returnt.id"
                v-bind:departure="returnt"
                v-bind:selectedFaresStore="selectedFaresStore"
                tripdir="return"
                @update-selected-class="updateReturnClass"
              />
            </div>
          </div>
          <div class="form-group text-center mini-widget--actions">
            <a
              href="#"
              class="btn btn-ghost btn-ghost-yellow mrgn-rght-md"
              @click.prevent="modifyTrip"
              >{{ $t("modifytrip") }}</a
            >
            <button
              type="submit"
              id="tripNext"
              class="btn btn-primary"
              :disabled="!canClickNext"
            >
              {{ $t("page2next") }}
            </button>
          </div>
        </form>
      </div>
      <div class="no-results container" v-cloak v-else>
        <h1 id="wb-cont">{{ $t("notripsfound") }}</h1>
        <p>
          {{ $t("noresults") }}
          <a
            href="#"
            class="btn btn-ghost btn-ghost-yellow"
            @click.prevent="modifyTrip"
            >{{ $t("modifytrip") }}</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import staticErrorList from "../components/staticErrorList.vue";
import tripItem from "../components/tripItem.vue";

export default {
  components: {
    staticErrorList,
    tripItem,
  },
  data() {
    return {
      errors: [],
      active_el: "",
      activeFare: "",
      selectedFareClass: "",
      selectedReturnClass: "",
    };
  },
  watch: {},
  beforeCreate() {},
  created() {
    if (!this.lexicons.length) {
      this.$store.dispatch("getLexicons");
    }
  },
  mounted() {},
  computed: {
    currentFrom() {
      return this.$store.state.trips.departures[0].from;
    },
    currentTo() {
      return this.$store.state.trips.departures[0].to;
    },
    productId() {
      return this.$store.state.current_product._id;
    },
    origin() {
      return this.$store.state.originId;
    },
    destination() {
      return this.$store.state.destinationId;
    },
    hasTrips() {
      if (Object.keys(this.$store.state.trips).length) {
        return this.$store.state.trips.departures.length;
      } else {
        return false;
      }
    },
    hasReturnTrips() {
      return this.$store.state.trips.returns;
    },
    tripDate() {
      return this.$store.state.departure;
    },
    passengerDetails() {
      var passengerArray = [];
      for (const [key, value] of Object.entries(this.selectedFaresStore)) {
        if (value > 0) {
          let currentType = this.fares.filter(function (fare) {
            return fare._id == key;
          });
          passengerArray.push(value + " " + currentType[0].name);
        }
      }
      return passengerArray.join(", ");
    },
    canClickNext() {
      return (
        (this.tripType == "oneway" && this.departureTripId) ||
        (this.tripType == "roundtrip" &&
          this.departureTripId &&
          this.returnTripId)
      );
    },
    ...mapState([
      "lexicons",
      "tripType",
      "departure",
      "selectedFaresStore",
      "fares",
      "fareString",
      "departureTripId",
      "departureFareClass",
      "returnTripId",
      "returnFareClass",
      "trips",
      "isDeepLinkLoading",
    ]),
  },
  methods: {
    modifyTrip: function () {
      this.$router.push("/");
    },
    to24time: function (value) {
      var ts = value;
      var H = +ts.substr(0, 2);
      var h = H % 12 || 12;
      h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
      var ampm = H < 12 ? " <span>am</span>" : " <span>pm</span>";
      ts = h + ts.substr(2, 3) + ampm;
      return ts;
    },
    toDuration: function (value) {
      var ts = value;
      ts = ts.replace(":", " h ");
      return ts + " min";
    },
    sortClasses: function (classes) {
      function compareValues(key, order = "asc") {
        return function innerSort(a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
          }

          const varA =
            typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
          const varB =
            typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

          let comparison = 0;
          if (varA > varB) {
            comparison = 1;
          } else if (varA < varB) {
            comparison = -1;
          }
          return order === "desc" ? comparison * -1 : comparison;
        };
      }
      return classes.sort(compareValues("order"));
    },
    updateClass: function (selectedClass) {
      this.selectedFareClass = selectedClass;
      // eslint-disable-next-line
      //console.log(selectedClass);
    },
    updateReturnClass: function (selectedClass) {
      this.selectedReturnClass = selectedClass;
    },
    filterError: function (key) {
      let filteredError = this.errors.filter(function (error) {
        return error.key == key;
      });
      return filteredError;
    },
    submitDeparture: function () {
      this.errors = [];

      if (this.$store.state.departureFareClass === "") {
        this.errors.splice(1, 0, {
          key: "departure",
          value:
            'You need to select at least one <a href="#departure-trips">departure trip</a>.',
        });
      }
      if (
        this.tripType === "roundtrip" &&
        this.$store.state.returnFareClass === ""
      ) {
        this.errors.splice(2, 0, {
          key: "return",
          value:
            'You need to select at least one <a href="#return-trips">return trip</a>.',
        });
      }
      if (!this.errors.length) {
        this.$router.push("/trips/passengers");
      } else {
        // eslint-disable-next-line
        jQuery("html, body").animate(
          {
            // eslint-disable-next-line
            scrollTop: jQuery("#error-list").offset().top,
          },
          1000
        );
      }
    },
  },
  filters: {
    totalPrice: function (fares) {
      return fares
        .reduce(function (a, b) {
          return Number(a) + Number(b["valueToDisplay"]);
        }, 0)
        .toFixed(2);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.productId) {
      next((vm) => {
        vm.$store.dispatch("deepLinkTrips", to.query);
      });
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.productId) {
      this.$store.dispatch("deepLinkTrips", to.query);
    }
    next();
  },
};
</script>
<style lang="scss">
[v-cloak] {
  display: none;
}
.list-headers {
  background-color: #e2edfc;
  color: $brand-primary;
  font-size: 18px;
  font-weight: bold;
  border-radius: 2px;
  display: flex;
  padding: 15px 0px;
  margin-top: 20px;
}
.header-departure {
  padding-left: 50px;
}
.header-arrival {
  padding-left: 165px;
}
.header-firm {
  padding-left: 510px;
}
@media (max-width: 1199px) {
  .header-firm {
    padding-left: 320px;
  }
}
@media (max-width: 991px) {
  .header-firm {
    padding-left: 110px;
  }
}
.header-flexible {
  padding-left: 150px;
}
.trip-overview {
  border: 1px solid #b8b8b8;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  border-radius: 2px;
  overflow: hidden;
}
.trip-overview--departure {
  // &:after {
  //   content: "";
  //   background: url("../assets/trip-overview-arrow.svg") no-repeat;
  //   width: 120px;
  //   height: 20px;
  //   display: block;
  //   position: absolute;
  //   right: 0px;
  //   bottom: 5px;
  // }
  small {
    font-size: 18px;
    display: block;
    margin-top: 15px;
  }
}
.trip-overview-arrow {
  background: url("../assets/trip-overview-arrow.svg") no-repeat center center;
  height: 130px;
}
.bold {
  font-weight: bold;
}
.trip-overview-wrapper {
  background-color: #e2edfc;
  padding-top: 15px;
  font-size: 18px;
  font-weight: 300;
  padding-bottom: 15px;
  color: $brand-primary;
  .row {
    padding-bottom: 10px;
  }
  .col-sm-3 {
    font-size: 30px;
    font-weight: 300;
    line-height: 1.1;
    span {
      font-size: 18px;
    }
  }
}
.fares {
  color: $brand-primary;
  font-weight: bold;
  font-family: $font-family-base;
  .col-sm-2 {
    font-size: 32px;
    color: #757070;
    line-height: 1;
    font-weight: 500;
    small {
      font-size: 17px;
    }
  }
  .col-sm-4 {
    font-size: 32px;
    font-weight: 500;
    color: #757070;
    line-height: 1;
    small {
      font-size: 13px;
      font-style: italic;
    }
  }
  .col-sm-12 {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #cecece;
  }
  small {
    color: #6d6d6d;
    font-weight: 300;
  }
}
.loader-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.loader-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid $brand-primary;
  border-radius: 50%;
  animation: loader-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $brand-primary transparent transparent transparent;
}
.loader-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.loader-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.loader-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes loader-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
